<div class="h-100 d-flex flex-nowrap justify-items-start">
    <ui-page-header
        icon="icon-sigevs"
        [hasRefresh]="false"
        [hasReturn]="false"
        [routerLink]="['/home']"
        style="cursor: pointer;"
        subtitle="Sistema Inteligente de Gestão de Eventos Sanitários e Veterinários"
    >
        SIGEVS
    </ui-page-header>
    <span>



    </span>
    <ng-container *ngFor="let item of items$ | async">
        <ng-container *ngIf="getUserHasPermission(item.permissions)">
                <span
                    class="menu-item-container {{item.isSpecial ? 'special' : ''}} {{isRouteActive(item.route) ? 'active' : ''}}">
                    <a class="menu-item"
                       (click)="item.route && navigateTo(item.route)"
                       [routerLink]="[item.route]"
                       [title]="item.title"
                    >
                        {{ item.title }}
                    </a>
                    <span class="divisor" *ngIf="item.subRoutes?.length > 0"></span>
                    <ng-container *ngTemplateOutlet="template; context: { dropdownOpened: [false] }"></ng-container>
                    <ng-template #template let-dropdownOpened="dropdownOpened">
                        <ui-dropdown *ngIf="item.subRoutes?.length > 0">
                            <a drop-trigger
                               class="menu-item-button {{ dropdownOpened[0] ? 'active' : '' }}"
                            >
                                <i class="pi pi-chevron-{{dropdownOpened[0] ? 'up' :'down'}}"></i>
                            </a>

                            <ng-container *ngFor="let subItem of item.subRoutes">
                                <ui-drop-item
                                    (click)="navigateTo(subItem.route)"
                                    [routerLink]="[subItem.route]"
                                    [title]="subItem.title"
                                >
                                    {{ subItem.title }}
                                </ui-drop-item>
                            </ng-container>
                        </ui-dropdown>
                    </ng-template>
                </span>
        </ng-container>
    </ng-container>
</div>

<profile-widget
    [nomeUsuario]="usuario.nome"
    [links]="links"
    [alteraraSenha]="false"
>
</profile-widget>

